import React from "react";

export const ZomeIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none">
        <path
          d="M4 20V15H5V18.292L8.6 14.692L9.308 15.4L5.708 19H9V20H4ZM15.4 9.308L14.692 8.6L18.292 5H15V4H20V9H19V5.708L15.4 9.308Z"
          fill="white"
        />
      </svg>
    </div>
  );
};
